import React from "react";
import shape1 from "../../images/rsvp/shape-left.png";
import shape2 from "../../images/rsvp/shape-right.png";
import RSVPFrom2 from "../RSVPFrom2/RSVPFrom2";

interface RsvpSectionS3Props {
  rClass?: string;
}

const RsvpSectionS3: React.FC<RsvpSectionS3Props> = ({ rClass }) => {
  return (
    <section className={`wpo-contact-section-s3 style-4 ${rClass || ""}`}>
      <div className="container">
        <div className="contact-wrap">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="wpo-contact-section-wrapper">
                <div className="wpo-contact-form-area">
                  <div className="section-title">
                    <h2 className="poort-text poort-in-right">
                      Creating Elegant Moments, One Wedding at a Time.
                    </h2>
                  </div>
                  <RSVPFrom2 />
                </div>
              </div>
            </div>
          </div>

          {/* Decorative shapes */}
          <div className="shape-1">
            <img src={shape1} alt="decorative shape left" />
          </div>
          <div className="shape-2">
            <img src={shape2} alt="decorative shape right" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default RsvpSectionS3;
